import { z } from 'zod';
import theme from '../../theme';
import { ErrorMessages } from '../../utils/consts';

export const SignInSx = {
  backgroundImage: `url(${import.meta.env.VITE_DO_SPACE_URL}/assets/gradient-nautical-navy-rough-abstract-background-design%201.png)`,
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover',
  height: '100dvh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

export const PaperSx = {
  width: 532,
  padding: '46px 40px 54px 40px',
};

export const TitleSx = {
  fontSize: '36px',
  marginTop: '2px',
  fontWeight: 600,
  letterSpacing: '1px',
  lineHeight: '40px',
  textAlign: 'center',
  color: theme.palette.customColors.gray[950],
};

export const ExplanationTextSx = {
  fontSize: '16px',
  lineHeight: '24px',
  textAlign: 'center',
  color: theme.palette.customColors.gray[950],
  margin: '16px 0 40px 0',
};

export const PasswordSx = {
  margin: '16px 0 12px 0',
  width: '100%',
};

export const EyeContainerSx = {
  display: 'flex',
  '&:hover': {
    cursor: 'pointer',
  },
};

export const LinkSx = {
  display: 'inline-block',
  fontSize: '14px',
  color: theme.palette.customColors.blue[500],
  marginBottom: '32px',
  float: 'inline-end',
  '&:hover': {
    cursor: 'pointer',
    textUnderlineOffset: '3px',
    textDecoration: 'underline',
  },
};

export const LoginButtonSx = {
  height: '44px',
  width: '100%',
  backgroundColor: theme.palette.customColors.blue[500],
  '&.Mui-disabled': {
    backgroundColor: theme.palette.customColors.blue[500],
    color: theme.palette.common.white,
    opacity: 0.5,
  },
};

export const ErrorMessageSx = {
  color: theme.palette.error.main,
  marginTop: '12px',
};

export const formSchema = z.object({
  emailOrUsername: z
    .string()
    .min(1, { message: ErrorMessages.FIELD_IS_REQUIRED })
    .default(''),

  password: z
    .string()
    .min(1, { message: ErrorMessages.FIELD_IS_REQUIRED })
    .default(''),
});

export type FormData = z.infer<typeof formSchema>;
